export default __webpack_public_path__ + "static/media/notebook.c9983b2d.png";